import { render, staticRenderFns } from "./FullscreenNotificationLayout.vue?vue&type=template&id=0ca6cbe9&scoped=true&"
import script from "./FullscreenNotificationLayout.vue?vue&type=script&lang=ts&"
export * from "./FullscreenNotificationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenNotificationLayout.vue?vue&type=style&index=0&id=0ca6cbe9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6cbe9",
  null
  
)

export default component.exports